import React from "react";
import HelpMessagesView from "./components/HelpMessagesView";
import { Biscuit } from "../../../utils";
import { isViewVisible } from "../../../utils/ViewSettings";
import t from "../../helpers/t";
import Rbac from "../../../utils/Rbac";

export const rbac = new Rbac({
  _rbac: {
    admin: { write: true },
    manager: { write: true },
    "booking-manager": { write: false },
    "manager-location": { write: false },
    user: { write: false },
    "garage-staff": { write: false },
  },
});

export const HelpMessagesPage = (props) => {
  let _view =
    typeof props.view === "undefined" || props.view === null
      ? "index"
      : props.view;
  let indexView =
    Biscuit.get("user.is_superuser") === "true" ? "helpMessages" : "";
  const language = Biscuit.get("user.lang").replace("-", "_");
  return (
    <>
      {(_view == "helpMessages" ||
        (_view == "index" && indexView == "helpMessages")) && (
        <HelpMessagesView
          name={t("help messages")}
          dispatch={props.dispatch}
          language={language}
          params={props.params}
          returnPath={props.returnPath}
          rbac={rbac}
          isViewVisible={isViewVisible}
          t={t}
          Biscuit={Biscuit}
          helpMessageEdit={props.states.helpMessageEdit}
          helpMessageAdd={props.states.helpMessageAdd}
          helpMessageId={props.states.helpMessageId}
          helpMessageItemEdit={props.states.helpMessageItemEdit}
          helpMessageItemAdd={props.states.helpMessageItemAdd}
          helpMessageItemId={props.states.helpMessageItemId}
        />
      )}
    </>
  );
};
